import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminAsset } from '../../../api/cabsHomepageAdmin';

const AdminCabsVehicleBanner = () => (
  <CabCrudPage
    title="Vehicle Banner"
    description="Manage vehicle banner tiles shown on the cabs homepage."
    resource="vehicle-banners"
    uploadHandler={uploadAdminAsset}
    enableReorder
    defaultItem={{
      name: '',
      category: '',
      imageUrl: '',
      sortOrder: 0,
      isActive: true,
    }}
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'category', label: 'Category' },
      { key: 'sortOrder', label: 'Sort' },
    ]}
    fields={[
      { name: 'name', label: 'Name', required: true },
      { name: 'category', label: 'Category' },
      { name: 'imageUrl', label: 'Image', type: 'image', required: true },
      { name: 'sortOrder', label: 'Sort order', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsVehicleBanner;
